// Sidebar navigation config (bilingual labels). Slugs match backend data.
export const SERVICE_ITEMS = [
  { slug: "on-page-seo", da: "On-page SEO", en: "On-page SEO" },
  { slug: "off-page-seo-linkbuilding", da: "Off-page SEO & Linkbuilding", en: "Off-page & Link building" },
  { slug: "teknisk-seo", da: "Teknisk SEO", en: "Technical SEO" },
  { slug: "ecommerce-seo", da: "Ecommerce SEO", en: "Ecommerce SEO" },
  { slug: "international-seo", da: "International SEO", en: "International SEO" },
  { slug: "lokal-seo", da: "Lokal SEO", en: "Local SEO" },
  { slug: "seo-strategi", da: "SEO Strategi", en: "SEO Strategy" },
  { slug: "seo-audit", da: "SEO Audit", en: "SEO Audit" },
  { slug: "ai-seo", da: "AI SEO (GEO)", en: "AI SEO (GEO)" },
  { slug: "shopify-seo", da: "Shopify SEO", en: "Shopify SEO" },
  { slug: "woocommerce-seo", da: "WooCommerce SEO", en: "WooCommerce SEO" },
  { slug: "seo-migreringer", da: "SEO Migreringer", en: "SEO Migrations" },
  { slug: "webinar", da: "SEO-webinar", en: "SEO Webinar" },
  { slug: "kursus", da: "SEO Kursus", en: "SEO Course" },
];

// Subset shown in the sidebar accordion (kept short so it fits without
// scroll). The full list is still crawlable from every route via the
// Footer's site-links block, so Google/GPTBot/ClaudeBot can discover
// every service page even though the sidebar only surfaces a subset.
export const SERVICE_MENU_ITEMS = [
  { slug: "on-page-seo", da: "On-page SEO", en: "On-page SEO" },
  { slug: "off-page-seo-linkbuilding", da: "Off-page SEO & Linkbuilding", en: "Off-page & Link building" },
  { slug: "teknisk-seo", da: "Teknisk SEO", en: "Technical SEO" },
  { slug: "ecommerce-seo", da: "Ecommerce SEO", en: "Ecommerce SEO" },
  { slug: "seo-strategi", da: "SEO Strategi", en: "SEO Strategy" },
  { slug: "ai-seo", da: "AI SEO (GEO)", en: "AI SEO (GEO)" },
];

// Subset shown in the sidebar menu. Full list still crawlable from Footer.
export const STACK_ITEMS = [
  { slug: "seo", da: "SEO Tech Stack", en: "SEO Tech Stack" },
  { slug: "marketing", da: "Marketing Tech Stack", en: "Marketing Tech Stack" },
  { slug: "ai", da: "AI Tech Stack", en: "AI Tech Stack" },
  { slug: "ecommerce", da: "Ecommerce Tech Stack", en: "Ecommerce Tech Stack" },
  { slug: "content", da: "Content Tech Stack", en: "Content Tech Stack" },
];

export const PROJECT_ITEMS = [
  { slug: "linksasaservice", da: "LinksAsAService", en: "LinksAsAService" },
  { slug: "shopseo", da: "ShopSEO.agency", en: "ShopSEO.agency" },
  { slug: "dreamprint", da: "Dreamprint.art", en: "Dreamprint.art" },
];

// Full list of all tech stacks — surfaced in the Footer's site-links block
// on every route so crawlers can discover every stack landing page without
// the sidebar accordion having to render 9 items.
export const STACK_ITEMS_ALL = [
  { slug: "seo", da: "SEO Tech Stack", en: "SEO Tech Stack" },
  { slug: "marketing", da: "Marketing Tech Stack", en: "Marketing Tech Stack" },
  { slug: "ai", da: "AI Tech Stack", en: "AI Tech Stack" },
  { slug: "ecommerce", da: "Ecommerce Tech Stack", en: "Ecommerce Tech Stack" },
  { slug: "content", da: "Content Tech Stack", en: "Content Tech Stack" },
  { slug: "productivity", da: "Productivity Tech Stack", en: "Productivity Stack" },
  { slug: "some", da: "SoMe Tech Stack", en: "SoMe Tech Stack" },
  { slug: "shopify", da: "Shopify Tech Stack", en: "Shopify Tech Stack" },
  { slug: "gtm", da: "GTM Tech Stack", en: "GTM Tech Stack" },
];
